import React from 'react';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import * as ST from './styled';

interface IProps {
    withForm: boolean,
    companyName: string,
    clickHandler: () => void,
}

const HeaderTitle: React.FC<IProps> = ({ clickHandler, companyName, withForm }) => {
    return (
        <ST.RowMiddle middle='xs'>
            <ST.Col xs={12}>
                <ST.Title>{companyName} сервис</ST.Title>
                <ST.Text>Решение технических проблем и настройка работы ваших домашних устройств</ST.Text>
                <ST.Form>
                { withForm &&
                    <ST.RowButton data-test={'button-block'}>
                        <ST.ColButton xs={12} sm={12}>
                            <ST.Button
                                type={btnTypes.ACCENT}
                                onClick={clickHandler}
                                data-test={'button'}
                            >
                                Получить консультацию
                            </ST.Button>
                        </ST.ColButton>
                    </ST.RowButton>
                }
                </ST.Form>
            </ST.Col>
        </ST.RowMiddle>
    );
};

export default HeaderTitle;
